@if (appUserAuthService.$authStateReady()) {
  <ion-app [ngClass]="appClasses">
    @if (showTryAppBanner) {
      <div class="label-xsmall primary on-primary-text try-app-banner">
        Welcome to Pueblo! Our app is a better experience ❤️
        <div>
          <a
            mat-raised-button
            class="feedback-button"
            [href]="storeLink"
            target="_blank"
          >
            Try the app
          </a>
        </div>
      </div>
    }
    <scroll-input [class.banner-showing]="showTryAppBanner">
      <hang-drawer context="app">
        <ion-router-outlet></ion-router-outlet>
      </hang-drawer>
    </scroll-input>
  </ion-app>
}

<div id="recaptcha-container-dev-only"></div>

<ng-template #reloadAppDialog>
  <span mat-dialog-title class="title-medium on-surface-text"
    >Update available
  </span>

  <div mat-dialog-content>
    <span class="body-medium on-surface-text"> Reload app to update </span>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-dialog-close mat-button class="error-button">Ignore</button>
    <button mat-dialog-close mat-flat-button (click)="reloadApp()">
      Reload
    </button>
  </div>
</ng-template>

<ng-template #updateAppInStoreDialog>
  <span mat-dialog-title class="title-medium on-surface-text"
    >Update available
  </span>

  <div mat-dialog-content>
    <span class="body-medium on-surface-text">
      Install new update from store
    </span>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-dialog-close mat-button class="error-button">Ignore</button>
    <a mat-dialog-close mat-flat-button [href]="storeLink" target="_blank">
      Update
    </a>
  </div>
</ng-template>

<ng-template #loginSheet let-data>
  <login
    [contextText]="data?.contextText ?? ''"
    (loggedIn)="data?.onLoggedIn?.()"
  ></login>
</ng-template>

<div class="stowed-cached-pages">
  <div #stowedPagesContainer></div>
</div>

<chat-focus-overlay></chat-focus-overlay>
<pueblo-dialogs></pueblo-dialogs>
<pueblo-sheets></pueblo-sheets>
<pueblo-menus></pueblo-menus>

<pueblo-confetti #confetti></pueblo-confetti>
